import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useContestSubscription } from '../modules/ContestSubscription/useContestSubscription';
import { useUserStore } from '../stores/user.store';
import { ElMessage } from 'element-plus';

export async function subscriptionGuard(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
  // Solo aplicar el guard a la ruta de SubscribeModels
  if (to.name !== 'SubscribeModels') {
    next();
    return;
  }

  const contestId = to.params.contest_id;
  if (!contestId) {
    ElMessage.error('ID de concurso no válido');
    next('/');
    return;
  }

  const userStore = useUserStore();
  const userId = userStore.user?.idUser;

  if (!userId) {
    ElMessage.error('Usuario no autenticado');
    next('/login');
    return;
  }

  const { hasActiveSubscription } = useContestSubscription();

  try {
    const response = await hasActiveSubscription(Number(userId), Number(contestId));
    console.log('Subscription response:', response); // Debug log

    const isActive = response.isActive;

    if (isActive) {
      next(); // Permitir acceso a SubscribeModels
    } else {
      // Redirigir a la pantalla de suscripción, conservando el modelo a inscribir (si vino desde "Mis Modelos")
      next({ path: `/home/contest/subscription/${contestId}`, query: to.query });
    }
  } catch (error) {
    console.error('Error verificando suscripción:', error);
    ElMessage.error('Error al verificar la suscripción');
    next('/home');
  }
}

/**
 * Evita volver a la pantalla de selección de plan si el usuario ya tiene una
 * suscripción activa para el concurso: lo redirige siempre a SubscribeModels.
 */
export async function alreadySubscribedGuard(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
  const contestId = to.params.contest_id;
  const userId = useUserStore().user?.idUser;

  if (!contestId || !userId) {
    next();
    return;
  }

  const { hasActiveSubscription } = useContestSubscription();

  try {
    const response = await hasActiveSubscription(Number(userId), Number(contestId));
    if (response.isActive) {
      next({ name: 'SubscribeModels', params: { contest_id: contestId }, query: to.query, replace: true });
      return;
    }
  } catch (error) {
    // Si falla la verificación, dejar que la vista de planes maneje el estado
  }
  next();
}
